import React, { PureComponent, Fragment } from "react";
import { Metric } from "./../Utils/Utils.js";
import Heading from "./../Elements/Heading";

class AuditSummary extends PureComponent {
  render() {
    const { data } = this.props;
    return (
      <Fragment>
        <div className="row mt-2 d-flex align-items-start">
          <div className="col-6 col-md-2 mb-3 mb-md-0">
            <Heading size={6} className={"mb-1"}>
              Free Trial Starts <br /> by Vindicia
            </Heading>
            <Metric {...data.free_trial_starts.vindicia} size={"md"} />
          </div>

          <div className="col-6 col-md-2 mb-3 mb-md-0">
            <Heading size={6} className={"mb-1"}>
              Free Trial Starts <br /> by Plaform
            </Heading>
            <Metric {...data.free_trial_starts.platform} size={"md"} />
          </div>

          <div className="col-6 col-md-2 mb-3 mb-md-0">
            <Heading size={6} className={"mb-1"}>
              Cancellations <br /> by Vindicia
            </Heading>
            <Metric {...data.cancellations.vindicia} size={"md"} />
          </div>

          <div className="col-6 col-md-2 mb-3 mb-md-0">
            <Heading size={6} className={"mb-1"}>
              Cancellations <br /> by Platform
            </Heading>
            <Metric {...data.cancellations.platform} size={"md"} />
          </div>

          <div className="col-6 col-md-2 mb-3 mb-md-0">
            <Heading size={6} className={"mb-1"}>
              Total Subs <br /> by Vindicia
            </Heading>
            <Metric {...data.total_subs.vindicia} size={"md"} />
          </div>

          <div className="col-6 col-md-2 mb-3 mb-md-0">
            <Heading size={6} className={"mb-1"}>
              Total Subs <br /> by Platform
            </Heading>
            <Metric {...data.total_subs.platform} size={"md"} />
          </div>
        </div>
      </Fragment>
    );
  }
}

export default AuditSummary;
